module.exports = __webpack_public_path__ + "static/media/Info_Details.6b5b3e4f.svg";